// ANCHOR React
import React from 'react';

// ANCHOR Base
import { withStyle } from 'baseui';
import { PopoverOverrides } from 'baseui/popover';
import { Block, BlockOverrides } from 'baseui/block';
import { ButtonOverrides } from 'baseui/button';

// ANCHOR Components
import { Skeleton } from '@lyon/components/utils/Skeleton';
import { TooltipDisabledButton } from '../TooltipDisabledButton';
import { ContentBuyButton } from './ContentBuyButton';

// ANCHOR Styles
import { SKELETON, BLOCK } from './styles';

const PriceSkeleton = withStyle(Skeleton, SKELETON);

export interface IContentBuyOverrides {
  block?: BlockOverrides;
  button?: ButtonOverrides;
  tooltip?: PopoverOverrides;
  tooltipBlock?: BlockOverrides;
}

interface IProps {
  price?: number;
  paymentLink?: string;
  isLoading?: boolean;
  isRestricted?: boolean;
  restrictedMessage?: string;
  onClick: () => Promise<void>;
  overrides?: IContentBuyOverrides;
}

export const ContentBuy = React.memo(({
  price,
  paymentLink,
  isLoading = false,
  isRestricted = false,
  restrictedMessage,
  onClick,
  overrides,
}: IProps) => {
  if (isRestricted && !restrictedMessage) {
    return null;
  }

  if (typeof price !== 'undefined' && isRestricted != null && !isLoading) {
    return (
      <Block overrides={overrides?.block || BLOCK}>
        <TooltipDisabledButton
          content={restrictedMessage || ''}
          isDisabled={isRestricted && !!restrictedMessage}
          overrides={{
            tooltip: overrides?.tooltip,
            block: overrides?.tooltipBlock,
          }}
        >
          <ContentBuyButton
            price={price}
            disabled={isRestricted}
            onClick={onClick}
            overrides={overrides?.button}
            paymentLink={paymentLink}
          />
        </TooltipDisabledButton>
      </Block>
    );
  }

  return <PriceSkeleton />;
});
